module.exports = __webpack_public_path__ + "static/media/SL 7-8.7ea3d388.mp3";